// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".back-button[data-v-8d912244]{display:flex;align-items:center;gap:5px;width:-moz-fit-content;width:fit-content}.back-button-label[data-v-8d912244]{font-size:20px;color:#801512}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
